import { Routes } from "@angular/router";
import { revenueManagerGuard } from '../hospitality/revenue-manager/revenue-manager.guard';
import { bookingOverviewGuard } from '../hospitality/booking-overview/booking-overview.guard';

export const featureRoutes: Routes = [
  { path: '', redirectTo: '/pages/revenue-manager', pathMatch: 'full' },
  {
    path: 'revenue-manager',
    canActivate: [revenueManagerGuard],
    loadComponent: () => import('../hospitality/revenue-manager/revenue-container/revenue-container.component').then(
      m => m.RevenueContainerComponent ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('../hospitality/revenue-manager/components/calendar-table/calendar-table.component').then(
          m => m.CalendarTableComponent ),
      },
    ]
  },
  {
    path: 'booking-overview',
    canActivate: [bookingOverviewGuard],
    loadComponent: () => import('../hospitality/booking-overview/booking-overview-page/booking-overview-page.component').then(
      m => m.BookingOverviewPageComponent ),
  }
]
